import api from './api';

const authService = {

  login: async (data) => {
    const res = await api.post('/api/login', data);
    return res.data;
  },

  logout: async () => {
    return api.post('/api/logout');
  },

  getUser: async () => {
    const res = await api.get('/api/user');
    return res.data;
  },
};

export default authService;
